<template lang="pug">
	div(v-if="p_popupParams" id="tablePopupId" class="popup-content")
		<span @click="m_closePopup" class="topright-close">&times;</span>
		kt-table(v-bind="d_popupParams")
</template>
<script>
import util from "@/utils/util.js";
import refData from "@/utils/ref-data.js";
import KTTable from "@/components/Ctrl/KT-Table.vue";;
export default {
	name: "kt-tablePopup",
	components: {"kt-table": KTTable},
	created() {},
	mounted() {},
	data() {
		return {
			d_popupParams:{ p_appEntKey:this.p_appEntKey,
			                p_opts:this.p_opts,
							p_cols:this.p_cols,
							p_tbNote:this.p_tbNote,
							p_tbInfo:this.p_tbInfo,
							p_popupParams:this.p_popupParams,
							p_style:this.p_style,
							p_showBtns:{searchBar:false,saveCancel:false,sync:false,barPieChart:false,
										remindOpt:false,reports:false},
							},
		};
	},
	props: {
		p_appEntKey: {type: String, required: true},
        p_opts:Object,
		p_cols:Object,
		p_tbNote: String,
		p_tbInfo: String,
		p_popupParams: String,
		p_style:Object,
	},
	computed: {},
	methods: {
		m_closePopup(){
			this.p_popupParams=null;
			this.$parent.d_popupParams=null;
		},
	},
	watch: {
		p_popupParams(nv,ov){
							if(nv) this.d_popupParams={ p_appEntKey:this.p_appEntKey,
														p_opts:this.p_opts,
														p_cols:this.p_cols,
														p_tbNote:this.p_tbNote,
														p_tbInfo:this.p_tbInfo,
														p_popupParams:nv,
														p_style:this.p_style,
														p_showBtns:{searchBar:false,saveCancel:false,sync:false,barPieChart:false,
																	remindOpt:false,reports:false},
														};
							
							
							},
	},
}
</script>
<style scoped lang="less">
.popup-content {
   position:fixed;
  background-color: #f1f1f1;
  max-width: 1100px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  top: 100px;
  left:450px;
  z-index: 9;
}
.topright-close {
  float: right;
  cursor: pointer;
  font-size: 28px;
  color:red;
}
.topright-close:hover {color: green;}
</style>